import Mustache from "mustache";
import Search, { ViewFilterType, SearchInitConfig, SearchClientConfig } from "../search";
import Utility from '../../classes/utility';
import AlumniBusinessCustomRender from "../customRenders/alumni-business-render";
import TextFilters, { TextFilterTypes } from "../utilities/text-filters";

// awards templates
const searchParentTemplate = require('/src/templates/components/search/alumni-business/search-parent-tpl').default;
const itemParentTemplate = require('/src/templates/components/search/alumni-business/item-parent-tpl').default;
const itemTemplateList = require('/src/templates/components/search/alumni-business/item-tpl--list').default;
const itemEmptyTemplate = require('/src/templates/components/search/alumni-business/item-empty-tpl').default;

class AlumniBusinessSearch extends Search {
    private landingSearchElement: HTMLElement;
    private landingSearchResults: HTMLElement;
    private landingSearchBox: HTMLElement;
    
    constructor(landingSearchElement: HTMLElement, clientConfig: SearchClientConfig, initConfig: SearchInitConfig) {
        super(clientConfig, initConfig);

        // align feature business on top of results area
        try {
            document.getElementsByClassName("page-content")[0].insertBefore(
                document.querySelector('main > section div.col-12.d-lg-flex.align-items-stretch.mb-4').closest("section"), document.getElementsByClassName("results-area")[0])
        } catch (error) {
            // silently fail
        }
        this.landingSearchElement = landingSearchElement;
        this.index.setSettings({
            customRanking: ['asc(title)']}).then(() => {});
        this.landingSearchResults = document.querySelector(`.${landingSearchElement.dataset.id}-results`)
        this.renderParent();
        this.initConfigOverride();
    }

    private initConfigOverride() {
        this.initConfig = {
            searchBoxId: this.landingSearchBox.id,
            resultContainerId: "landing-search-hits",
            queryName: "abl",
            allowEmptyQuery: true,
            showOnLoad: true,
            activeTemplate: "list",
            infiniteScroll: true,
            textboxPlaceholder: "Search businesses...",
            templates: {
                list: itemTemplateList,
                empty: itemEmptyTemplate
            },
            customRender: AlumniBusinessCustomRender.customRender
        };
    }

    private renderParent() {
        let self = this;
        self.landingSearchElement.innerHTML = Mustache.render(searchParentTemplate, {
            id: self.landingSearchElement.dataset.id
        });
        self.landingSearchResults.innerHTML = Mustache.render(itemParentTemplate, {
            id: self.landingSearchElement.dataset.id
        });
        self.landingSearchBox = self.landingSearchElement.querySelector(".landing-search-box");
    }

    private onLoadFacets(facets: Array<any>) {
        let self = this;
        facets.forEach(facet => {
            self.addFacet({
                field: facet.key,
                value: facet.value,
            });
        });
    }

    private onLoadViewFilters() {
        let self = this;
        self.addViewFilter({
            filterType: ViewFilterType.Clear,
            elementId: `${self.landingSearchElement.dataset.id}-clearFilters`,
            cssClasses: {
                button: "btn btn-link text-white text-decoration-none clear-filters"
            }
        });
        self.addViewFilter({
            elementId: `categories`,
            capitalize: false,
            cssClasses: {
                select: "form-control color-cool-dark-grey"
            }
        });

        // wrike#1080358403 - remove related programs for business listings
        // self.addViewFilter({
        //     elementId: `relatedPrograms`,
        //     cssClasses: {
        //         select: "form-control color-cool-dark-grey"
        //     }
        // });
    }

    private onLoadSearch() {
        // get the algolia search box
        //self.searchArea = self.landingSearchElement.querySelector("div");
        if (this.landingSearchBox) {
            // init algolia
            this.init();
        }
    }

    private onLoadViewUpdates() {
        let self = this;

        self.customSearch = function () {
            let clearFiltersBtn = document.getElementById(`${self.landingSearchElement.dataset.id}-clearFilters`) as HTMLDivElement;

            if (clearFiltersBtn) {
                // display clear filters text
                clearFiltersBtn.classList.remove("d-none");
                clearFiltersBtn.classList.add("d-inline-block");
            } else {
                clearFiltersBtn.classList.add("d-none");
                clearFiltersBtn.classList.remove("d-inline-block");
                self.setSearchBoxValue("");
            }
        }
    }

    private onLoadtextFilters() {
        let self = this;
        let rc = document.getElementById(this.initConfig.resultContainerId).querySelector("ul");
        TextFilters.bindTextFilter(`${self.landingSearchElement.dataset.id}-name-textFilter`, rc, '.col-name', TextFilterTypes.Text);
    }

    override onLoad(facets: Array<any>) {
        this.onLoadFacets(facets);
        this.onLoadViewFilters();
        this.onLoadSearch();
        this.onLoadViewUpdates();
        this.onLoadtextFilters();
    }

    init() {
        super.init();

        // get query in URL - if set
        let query = Utility.getUrlParameter(this.initConfig.queryName);

        // trigger filters
        this.lazyloading = true;

        // trigger search on page load query
        if (query) {
            this.search.helper.setQuery(query)
            this.search.helper.search();
        }
    }
}
export default AlumniBusinessSearch;